// extracted by mini-css-extract-plugin
export default {"alert":"AuthAlert_alert__BXYHL","success":"AuthAlert_success__m0J3c","error":"AuthAlert_error__qNrtt"};